module.exports = __webpack_public_path__ + "static/3-f4929ccce029208cabc5a09d192abdbe.jpg";